import dayjs from 'dayjs';
import { StylistJob } from './checkin';

export enum BookingStatus {
  CallIn = 0,
  WalkIn = 1,
}

export interface BookingItem {
  id: number;
  date: Date;
  time: string;
  link: string;
}

export function createBookingItem(blob: any) {
  const bookedDate = blob.booking_date ? dayjs(blob.booking_date).toDate() : undefined;
  return {
    id: blob.booking_id,
    date: bookedDate,
    time: blob.booking_time,
    link: blob.booking_link,
  } as BookingItem;
}

export class BookingData {
  status: BookingStatus;
  bookingDate: string;
  bookingTime: string;
  stylists: any[];

  constructor(fields) {
    Object.assign(this, fields);
  }
}

export function createBookingData(blob: any): BookingData {
  return new BookingData({
    status: blob.status,
    bookingDate: blob.booking_date,
    bookingTime: blob.booking_time,
    stylists: (blob.stylists || []).map(formatStylist) as StylistJob[],
  });
}

function formatStylist(blob) {
  return {
    stylistId: blob.id,
    stylistName: `${blob.first_name} ${blob.last_name}`,
    jobs: (blob.services || []).map(service => {
      return {
        serviceId: service.service_id,
        serviceName: service.service_name,
      };
    }),
  };
}
